import { Injectable } from '@angular/core';

import { User } from '../models';

@Injectable()
export abstract class UsersManagementService {
    abstract verifyInviteTokenValidity(
        token: string
    ): Promise<{ valid: true; user: User } | { valid: false; error: 'Invalid' | 'Expired' }>;

    /**
     * Asynchronous operation to finalize the user invite process.
     */
    abstract finalizeUserCreation(token: string, password: string, confirmationPassword: string): Promise<void>;
}
